$(function(){

	require('./trumpsamerica.css');
	window.Tabletop = require('tabletop');
	const moment = require('moment');

	const table = require('./trumpsamerica.mustache');
	const cells = require('./trumpsamerica-cells.mustache');
	const quote = require('./trumpsamerica-blockquote.mustache');
	const tweet = require('./trumpsamerica-tweet.mustache');

	const $c = $('.int-trumpsamerica');
	var shown = 0;
	const DEFAULT_SHOWN = 10;
	const DEFAULT_ADD = 10;

	const spreadsheet_url = "https://docs.google.com/spreadsheets/d/1rxX15E6mZ4-VBWzRQ31KS74E3HIbA-RVKXg3PkHFXTI/pubhtml";

	Tabletop.init({
		key: spreadsheet_url,
		callback: spreadsheet_loaded,
		proxy: 'https://slate-features.s3.amazonaws.com',
		simpleSheet: true
	});

	function spreadsheet_loaded(incident_data) {
		incident_data.sort(function(a, b) { return moment(b.timestamp).toDate() - moment(a.timestamp).toDate(); });

		const incidents = incident_data.map(function(incident) {
			const time = moment(incident.timestamp);
			var timestamp = false;
			if (incident.isthisabackfill!=="Yes") {
				timestamp = `Posted ${formatTime(time)}`
			}

			return {
				timestamp: timestamp,
				title: incident.headline,
				content: getContent(incident)
			};
		});


		drawTable(DEFAULT_SHOWN);
		$c.resize(function() {
			console.log("resize");
		});

		function getContent(incident) {
			const arr = [];
			if (incident.quote.length) arr.push(quote.render({quote: incident.quote, sourcename: incident.sourcename, sourcelink: incident.sourcelink, sourcedate: formatTime2(moment(incident.datereported))}));
			if (incident.tweethtml.length) arr.push(tweet.render({tweet_html: incident.tweethtml}));
			return arr;
		}

		function drawTable(number) {
			const slice = incidents.slice(0, number);
			const table_html = table.render({cells: cells.render({incidents: slice}), not_all: true});
			$c.html(table_html);
			shown = number;

			$c.find('.trumpsamerica-more').click(()=>{ expandTable(DEFAULT_ADD); });
		}

		function expandTable(number) {
			const slice = incidents.slice(shown, shown+number);
			const cells_html = cells.render({incidents: slice});

			const $more = $c.find('.trumpsamerica-more-tr');
			$(cells_html).insertBefore($more);

			shown = shown+number;
			if (shown >= incidents.length) $more.hide();
		}

		function redrawTable() {
			const slice = incidents.slice(0, shown);

			const table_html = table.render({cells: cells.render({incidents: slice}), not_all: true});
			$c.html(table_html);

			$c.find('.trumpsamerica-more').click(()=>{ expandTable(DEFAULT_ADD); });

			if (shown >= incidents.length) $more.hide();
		}
	}

	function formatTime(time) {
		if (time.dayOfYear()==moment().dayOfYear() && time.year()==moment().year()) return time.fromNow();
		else if (time.month()==4 | time.month()==5 | time.month()==6) return time.format("MMMM D, YYYY h:mm a");
		else return time.format("MMM. D, YYYY h:mm a");
	}

	function formatTime2(time) {
		if (time.month()==4 | time.month()==5 | time.month()==6) return time.format("MMMM D, YYYY");
		else return time.format("MMM. D, YYYY");
	}
}); //end jQuery
